var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 114 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.984.014a2.588 2.588 0 0 1 1.45.599l54.162 46.02a2.55 2.55 0 0 1 .257 3.61 2.604 2.604 0 0 1-3.642.265L56.74 5.926 4.271 50.508a2.6 2.6 0 0 1-3.641-.265 2.55 2.55 0 0 1 .257-3.61L24.5 26.578V5.127h10.316V17.79L55.048.612a2.61 2.61 0 0 1 1.934-.6zm-.866 9.962L97.27 45.012V106H14.965V45.012zm18.706 44.895H59.859v14.964h14.965zm-21.2 0H38.659v14.964h14.965zm21.2 19.953H59.859v14.964h14.965zm-21.2 0H38.659v14.964h14.965z"
  })));
};

export default SvgHouse;